import {
  FILTER_MATCH_TYPE_SEPARATOR,
  FILTER_VALUE_SEPARATOR,
} from '@aibees/elephant/constants/filters';
import { SearchBrowseParams, SearchMatchType } from '@aibees/elephant/types';

export function buildDraft(
  field: string,
  params: Partial<SearchBrowseParams>,
  searchType: SearchMatchType
) {
  let draft = params.exact_match?.split(FILTER_VALUE_SEPARATOR) ?? [];
  const fieldDraft = draft.find((x) => x.includes(field));
  if (fieldDraft) {
    if (!fieldDraft.includes(searchType)) {
      draft = draft.filter((x) => x !== fieldDraft);
      draft.push(field + FILTER_MATCH_TYPE_SEPARATOR + searchType);
    }
  } else {
    draft.push(field + FILTER_MATCH_TYPE_SEPARATOR + searchType);
  }
  return draft.join(FILTER_VALUE_SEPARATOR);
}
